function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Awlays returns the variant type as an array, even if it's empty.
 *
 * @param variantList Variant definition to normalize.
 */
export var normalizeVariants = function normalizeVariants(variantList) {
  if (variantList) {
    if (Array.isArray(variantList)) {
      return variantList;
    }

    return [variantList];
  }

  return [];
};
/**
 * Check if the variant is included in the given set.
 *
 * @param variantList - Variant set to check
 * @param variant - Variant to check
 */

export var hasVariant = function hasVariant(variantList, variant) {
  if (variantList) {
    if (Array.isArray(variantList)) {
      return variantList.includes(variant);
    } else {
      return variantList === variant;
    }
  }

  return false;
};
/**
 * Safely add the given variant to the set.
 *
 * @param variantList - Variant set to add to
 * @param variant - Variant to add
 */

export var addVariant = function addVariant(variantList, variant) {
  return [].concat(_toConsumableArray(normalizeVariants(variantList)), [variant]);
};